import React from 'react';

import SignInButton from './SignInButton';
// import PwaInstallButtons from './PwaInstallButtons';

function SignInAndPWAButtons(props) {
  const align = props.align || (props.isMobile ? 'center' : 'left');
  const signInContent = props.children || (
    props.ios
      ? <>&nbsp;&nbsp;Sign in with Google</>
      : <>&nbsp;&nbsp;Get <span style={{fontWeight: 300}}>RSI Alerts</span> Now</>
  );

  return (
    <>
      <div className={`flex flex-col items-center gap-3 sm:flex-row ${align === 'left' ? 'md:justify-start justify-center' : 'justify-center'}`}>
        <SignInButton align={align} showDescription={false}>
          {signInContent}
        </SignInButton>
        {/* <PwaInstallButtons align={align} /> */}
      </div>
      <div className={`mb-1 mt-3 ${align === 'left' ? 'text-left' : 'text-center'} text-sm text-gray-500`} >
        <span>Set Up In <b>30 Seconds</b>. It's <b>Free</b> to Start. </span>
      </div>
    </>
  );
}

SignInAndPWAButtons.defaultProps = {
  align: null,
  ios: false,
  isMobile: false
};

export default SignInAndPWAButtons;
